export const counties = [
    "CO_CARLOW",
    "CO_CAVAN",
    "CO_CLARE",
    "CO_CORK",
    "CO_DONEGAL",
    "CO_DUBLIN",
    "CO_GALWAY",
    "CO_KERRY",
    "CO_KILDARE",
    "CO_KILKENNY",
    "CO_LAOIS",
    "CO_LEITRIM",
    "CO_LIMERICK",
    "CO_LONGFORD",
    "CO_LOUTH",
    "CO_MAYO",
    "CO_MEATH",
    "CO_MONAGHAN",
    "CO_OFFALY",
    "CO_ROSCOMMON",
    "CO_SLIGO",
    "CO_TIPPERARY",
    "CO_WATERFORD",
    "CO_WESTMEATH",
    "CO_WEXFORD",
    "CO_WICKLOW",
];
